import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { AdminAuthService } from './admin-auth.service';

@Injectable()
export class AdminAuthGuardUtilities  {
  event$: any;
    currUrl: string;

  constructor(
    private router: Router,
    private adminAuth: AdminAuthService,
  ) { 
    this.event$ = 
    this.router.events
    .subscribe(
      (event) => {
        if(event instanceof NavigationEnd) {
          this.currUrl = this.router.url;
          console.log('sample', this.currUrl);
          this.canActivate()
        }
      });

  }

  canActivate() {   
    let roleId = sessionStorage.getItem('getRoleId')
    if(roleId != '0' && roleId !='1' && roleId !='11' && roleId !='12' && this.currUrl == '/admin/utilities' ){
        console.log('our condition')
       return this.router.navigate(['**']);    
                          
    }
    else{
        return true
    } 
  }

}
